interface IStorageData {
  key: string;
  data: { key: string; data: any };
}

const dataType = (data) => {
  return Object.prototype.toString.call(data);
};

class StorageData {
  data: IStorageData | null;
  storageKey: string;

  constructor(storageKey) {
    this.data = null;
    this.storageKey = storageKey;
  }

  getData(key) {
    const parseData = localStorage.getItem(key) || "";

    if (!parseData) {
      return undefined;
    }

    return JSON.parse(parseData);
  }
  setData(key: string, value: any) {
    let currentData: string = "";
    this.storageKey = key;
    switch (dataType(value)) {
      case "[object Map]":
        let data = Array.from((value as Map<string, any>).entries());
        currentData = JSON.stringify(data);
        break;
      default:
        currentData = JSON.stringify(value);
        break;
    }

    localStorage.setItem(this.storageKey, currentData);
  }

  /** 只处理二维数组 */
  arrayToMap(value) {
    let map = new Map();
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (Array.isArray(item) && item.length) {
          map.set(item[0], item[1]);
        } else {
          throw new TypeError("unsupport");
        }
      });
    } else {
      throw new TypeError("unsupport");
    }
    return map;
  }
}

export default StorageData;
